exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ReactModalPortal{position:relative;z-index:8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":true,"config":{"path":"/var/www/prb-datafinder/client/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./app/prb-style-library/datacenter.scss
// module id = 433
// module chunks = 0